import { AssetCategory } from "../../classes";

const AssetCategoryModule = {
  namespaced: true,
  state: {
    assetCategories: [],
    assetCategory: {}
  },
  actions: {
    getAssetCategories: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await AssetCategory.getAssetCategories(params);
        commit("setAssetCategories", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    getAssetCategory: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await AssetCategory.getAssetCategory(params);
        commit("setAssetCategory", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    createAssetCategory: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await AssetCategory.createAssetCategory(params);
        // dispatch("getAssetCategories", { parameter: data?.subParameter });
        return data;
      } catch (e) {
        throw e;
      }
    },
    updateAssetCategory: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await AssetCategory.updateAssetCategory(params);
        return data;
      } catch (e) {
        throw e;
      }
    },
    removeAssetCategory: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await AssetCategory.removeAssetCategory(params);
        dispatch("getAssetCategories", { parameter: data?.subParameter });
        return data;
      } catch (e) {
        throw e;
      }
    }
  },
  getters: {
    getAssetCategory: state => {
      return state.assetCategory;
    },
    getAssetCategories: state => {
      return state.assetCategories.map(i => {
        return i;
      });
    }
  },
  mutations: {
    setAssetCategory: (state, payload) => {
      state.assetCategory = payload;
    },
    setAssetCategories: (state, payload) => {
      state.assetCategories = payload;
    }
  }
};

export default AssetCategoryModule;
